// Third-party
import useTranslation from 'next-translate/useTranslation';

import clsx from 'clsx';

import type { SocialInboxType } from '@/components/pages/conversations/SocialInbox/types';

// Constants/Libs/Types
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import Icon from '@/components/base/Icon';

interface SocialInboxTypeTitleProps {
    selected?: boolean;
    type: SocialInboxType;
    className?: string;
    classNameTextSize?: string;
}

export const SocialInboxTypeTitle = ({
    selected = false,
    type,
    className,
    classNameTextSize = 'text-xs'
}: SocialInboxTypeTitleProps) => {
    const { t } = useTranslation('conversations');

    return (
        <div className={clsx('flex items-center gap-2', className, classNameTextSize)}>
            <Icon
                icon={selected ? SOCIAL_INBOX_META[type].activeIcon : SOCIAL_INBOX_META[type].icon}
            />
            <span>{t(`tabs.${type}`)}</span>
        </div>
    );
};
